import { Component, OnInit, ViewChild } from '@angular/core';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalService } from 'ng-zorro-antd/modal';
// PatrolTemplateDetailComponent
import { FormBuilder, FormGroup } from '@angular/forms';
import { AuthState } from '../../../store/authInfo/auth-state';
import { Store } from '@ngxs/store';
// PatrolControlPreviewComponent
import { BudgetDetailDetailService } from '../../../service/budget-detail.service';
import { BudgetDetailItemComponent } from './budget-detail-item/budget-detail-item.component';
import { NzTreeSelectComponent } from 'ng-zorro-antd/tree-select';
import { CostService } from '../../../service/cost.service';


@Component({
  selector: 'app-budget-detail',
  templateUrl: './budget-detail.component.html',
  styleUrls: ['./budget-detail.component.less']
})
export class BudgetDetailComponent implements OnInit {

  // 业务类型提示框
  typeTooltip = '请选择';
  @ViewChild('costTypeTreeSelect') costTypeTreeSelect: NzTreeSelectComponent;
  pageIndex: number;
  pageSize: number;
  total = 0;
  loading = true;
  // 下拉框
  directors = [];
  // 查询结果
  data = [];
  validateForm: FormGroup;
  authState = null;
  checked = false;
  indeterminate = false;
  setOfCheckedId = new Set<number>();

  // 费用类型
  typeMap = new Map<number, any>();
  pTypes = [];
  // cost_type
  costTypes = [];
  constructor(
    private modalService: NzModalService,
    private message: NzMessageService,
    private fb: FormBuilder,
    private store: Store,
    private budgetDetailDetailService: BudgetDetailDetailService,
    private costService: CostService,
  ) { }

  async ngOnInit(): Promise<void> {
    this.authState = this.store.selectSnapshot<any[]>(AuthState);
    this.validateForm = this.fb.group({
      bdName: [null],
      costTypeId: [null]
    });
    this.queryTemplateData(1);
    // 填充下拉框
    const types = await this.costService.getCostTypeList();
    this.costTypes = this.initCostTypeTree(types);
  }
  treeSelectChanged(key) {
    this.fillTypeTooltip(key);
  }
  fillTypeTooltip(key) {
    if (key !== undefined && key !== null) {
      if (this.costTypeTreeSelect) {
        let currentNode = this.costTypeTreeSelect.getTreeNodeByKey(key);
        if (currentNode != null) {
          // 获取叶子节点完整路径，用于提示框
          let toolTip = `${currentNode.origin.title}`;
          while (currentNode.getParentNode()) {
            currentNode = currentNode.getParentNode();
            toolTip = `${currentNode.origin.title}-->${toolTip}`;
          }
          this.typeTooltip = toolTip;
        }
      }
    }
  }
  onAllChecked(checked: boolean): void {
    this.data.forEach(item => this.updateCheckedSet(item.bdid, checked));
    this.refreshCheckedStatus();
  }
  updateCheckedSet(id: number, checked: boolean): void {
    if (checked) {
      this.setOfCheckedId.add(id);
    } else {
      this.setOfCheckedId.delete(id);
    }
  }
  onItemChecked(id: number, checked: boolean): void {
    this.updateCheckedSet(id, checked);
    this.refreshCheckedStatus();
  }
  refreshCheckedStatus(): void {
    this.checked = this.data.every(item => this.setOfCheckedId.has(item.bdid));
    this.indeterminate = this.data.some(item => this.setOfCheckedId.has(item.bdid)) && !this.checked;
  }
  addBudgetDetail() {
    const modal = this.modalService.create({
      nzTitle: '增加预算明细',
      nzContent: BudgetDetailItemComponent,
      nzStyle: { top: '20px' },
      nzWidth: 700,
      // ev:nzContent(组件)
      nzOnOk: (ev) => {
        const budgetDetailForm = ev.getbudgetDetailForm();
        if (!this.validateFormData(budgetDetailForm)) {
          this.message.warning('预算明细数据验证未通过');
          return false;
        } else {
          // const questions = ev.getQuestions();
          const budgetDetail = {
            bdname: budgetDetailForm.value.bdname,
            bdid: budgetDetailForm.value.bdid,
            initValue: budgetDetailForm.value.initValue,
            mark: budgetDetailForm.value.mark,
            createBy: this.authState.userInfo.userId,
            costTypeId: budgetDetailForm.value.costTypeId,
            // controls: questions
          };
          this.budgetDetailDetailService.addBudgetDetail(budgetDetail).then((value) => {
            if (value) {
              this.queryTemplateData(1);
              this.message.success('创建成功');
              modal.close();
            } else {
              this.message.error('创建失败');
            }
          });
          return false;
        }
      },
      nzOnCancel: (ev) => {
      }
    });
  }
  // 批量删除明细
  deleteBudgetDetail() {
    this.modalService.confirm({
      nzTitle: '删除',
      nzContent: '你确定要删除选中预算明细?',
      nzOkText: '确定',
      nzCancelText: '取消',
      nzOnOk: () => {
        this.budgetDetailDetailService.batchDelete(this.setOfCheckedId).then((value) => {
          if (value > 0) {
            this.queryTemplateData(1);
          }
        });
      }
    });
  }
  // 预览表单
  previewTemplate(bdid) {
    this.budgetDetailDetailService.getBudgetDetail(bdid).then((value) => {
      const modal = this.modalService.create({
        nzTitle: '预算明细预览',
        nzContent: BudgetDetailItemComponent,
        nzStyle: { top: '20px' },
        nzWidth: 400,
        nzComponentParams: {
          // controls: data,
        },
        nzOkText: '关闭',
        nzCancelText: null,
        nzOnOk: (ev) => {
        }
      });
    });
  }
  // 编辑模板
  editBudgetDetail(bdid) {
    const modal = this.modalService.create({
      nzTitle: '编辑预算明细-' + bdid,
      nzContent: BudgetDetailItemComponent,
      // nzStyle: { top: '20px' },
      nzWidth: 700,
      nzComponentParams: {
        // 给组件传该记录的id
        bdid,
        code: 1
      },
      nzOnOk: (ev) => {
        const budgetDetailForm = ev.getbudgetDetailForm();
        if (!this.validateFormData(budgetDetailForm)) {
          this.message.warning('数据未验证通过');
          return false;
        } else {
          this.modalService.confirm({
            nzTitle: '修改',
            nzContent: '你确定要修改预算明细?',
            nzOkText: '确定',
            nzCancelText: '取消',
            nzOnOk: () => {
              // const questions = ev.getQuestions();
              const budgetDetail = {
                bdid,
                bdname: budgetDetailForm.value.bdname,
                initValue: budgetDetailForm.value.initValue,
                mark: budgetDetailForm.value.mark,
                // createBy: this.authState.userInfo.userId,
                costTypeId: budgetDetailForm.value.costTypeId
                // controls: questions
              };
              // tslint:disable-next-line:no-shadowed-variable
              this.budgetDetailDetailService.updateBudgetDetail(budgetDetail).then((value) => {
                console.log(`响应码：${value.code}`);
                if (value.code === 200) {
                  this.queryTemplateData(1);
                  this.message.success('修改成功');
                  modal.close();
                }
              });
            }
          });
          return false;
        }
      },
      nzOnCancel: (ev) => {
      }
    });
  }
  // 提交表单
  submitForm() {
    this.queryTemplateData(1);
  }
  // 重置表单
  resetForm() {
    this.validateForm.reset();
    this.queryTemplateData(1);
  }
  onPageIndexChange(pageIndex) {
    this.pageIndex = pageIndex;
    this.queryTemplateData(2);
  }
  /**
   * 查询模板数据
   * @param flag 1表示点击搜索按钮，2表示翻页
   */
  queryTemplateData(flag: number) {
    if (flag === 1) {
      this.pageIndex = 1;
      this.pageSize = 10;
    }
    // tslint:disable-next-line:max-line-length
    this.budgetDetailDetailService.getBudgetDetailListByCondition(this.validateForm.value, this.pageIndex, this.pageSize).then((value) => {
      this.loading = false;
      this.data = value.list;
      this.total = value.total;
    });
  }
  public validateFormData(validateForm) {
    // tslint:disable-next-line:forin
    for (const i in validateForm.controls) {
      validateForm.controls[i].markAsDirty();
      validateForm.controls[i].updateValueAndValidity();
    }
    return validateForm.valid;
  }
  initCostTypeTree(types: any[]) {
    const costTypes = [];
    for (const type of types) {
      const node = {
        title: type.typeName,
        value: type.typeId,
        key: type.typeId,
        isLeaf: true
      };
      if (type.parentId === 0) {
        costTypes.push(node);
      } else {
        const parent = this.typeMap.get(type.parentId);
        if (parent != null) {
          if (parent.children == null) {
            parent.children = [];
            parent.isLeaf = false;
          }
          parent.children.push(node);
        }
      }
      this.typeMap.set(type.typeId, node);
    }
    return costTypes;
  }
  public isEmpty(obj: any) {
    if (typeof obj === 'undefined' || obj === null || obj === '') {
      return true;
    } else {
      return false;
    }
  }
}
